import { ANALYTIC_EVENTS } from 'ggApp/modules/gaAnalytics/constants';
import { pushDataLayer } from 'ggApp/modules/tracking/actions';
import { CHECKOUT_FLOW_NAMES } from '../constants';

export const registerHomeAddressTest = (flow) => {
    let eventLabel;
    if (flow === CHECKOUT_FLOW_NAMES.CHECKOUT_WITH_HOME_ADDRESS) {
        eventLabel = 'active';
    } else {
        eventLabel = 'inactive';
    }
    const payload = {
        event: ANALYTIC_EVENTS.newCheckout,
        eventCategory: 'internal_test',
        eventAction: 'home_address_test',
        eventLabel,
    };
    pushDataLayer(payload);
};

export const registerToolTipActivation = (productSKU, userId, orderNumber) => {
    const step = 'order_review';
    const eventPayload = {
        event: ANALYTIC_EVENTS.gtmEvent,
        eventCategory: 'checkout',
        eventAction: 'tooltip',
        eventLabel: 'mietKauf',
        eventProperty: {
            step,
            productSKU,
            orderID: orderNumber,
            userID: userId,
        },
    };
    pushDataLayer(eventPayload);
};
